/* @flow */

import { getBraindateId } from '@e180/domain/lib/braindate/util';

import * as types from 'src/shared/app/check-in/action/uiCheckInActionTypes';
import { createReducer } from 'src/shared/core/util/reducerUtils';

/*
 |------------------------------------------------------------------------------
 | Initial state
 |------------------------------------------------------------------------------
 */

const initialState = {
  isAnimationRunning: {},
  isTakeOverOpen: {},
};

/*
 |------------------------------------------------------------------------------
 | Reducers
 |------------------------------------------------------------------------------
 */

const markAnimationAsRunning = (state: Object, { braindate }: Object) => ({
  ...state,
  isAnimationRunning: {
    ...state.isAnimationRunning,
    [getBraindateId(braindate)]: true,
  },
});

const markAnimationAsDone = (state: Object, { braindate }: Object) => ({
  ...state,
  isAnimationRunning: {
    ...state.isAnimationRunning,
    [getBraindateId(braindate)]: false,
  },
});

const markTakeOverAsOpen = (state: Object, { braindate }: Object) => ({
  ...state,
  isTakeOverOpen: {
    ...state.isTakeOverOpen,
    [getBraindateId(braindate)]: true,
  },
});

const markTakeOverAsClosed = (state: Object, { braindate }: Object) => ({
  ...state,
  isTakeOverOpen: {
    ...state.isTakeOverOpen,
    [getBraindateId(braindate)]: false,
  },
});

export default createReducer(initialState, {
  [types.MARK_CHECK_IN_ANIMATION_AS_RUNNING]: markAnimationAsRunning,
  [types.MARK_CHECK_IN_ANIMATION_AS_DONE]: markAnimationAsDone,
  [types.MARK_CHECK_IN_TAKE_OVER_AS_OPEN]: markTakeOverAsOpen,
  [types.MARK_CHECKIN_TAKE_OVER_AS_CLOSED]: markTakeOverAsClosed,
});
